/**
 * Customer-facing text for a rejected discount code. The backend returns a stable error_code
 * (+ params) next to its Polish `message` — see shop.logic.orders.DiscountCodeError — so the
 * storefront can show it in the shopper's language; `message` stays the fallback for codes this
 * bundle doesn't know yet.
 */
export function couponErrorMessage(
    res: { message?: string; error_code?: string | null; error_params?: Record<string, any> | null } | null | undefined,
    t: (key: string, fallback?: string) => string,
    fallback: string,
): string {
    if (res?.error_code) {
        const key = `cart.coupon_err.${res.error_code}`;
        const template = t(key, '');
        if (template) {
            return Object.entries(res.error_params || {}).reduce(
                (text, [name, value]) => text.split(`{${name}}`).join(String(value)),
                template,
            );
        }
    }
    return res?.message || fallback;
}
